// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HTML_wrapper__x0YUd"};